"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f2980 = void 0;
exports.f2980 = {
    "தமிழ்": [
        7296,
        7298,
        7299,
        7300
    ]
};
